export default __webpack_public_path__ + "static/media/suns.840d1c5b.jpg";